import { DatePicker as MUIDatePicker, DatePickerProps as MUIDatePickerProps } from '@mui/x-date-pickers-pro'
import { MIN_DATE } from '@shared/constants'

export const DatePicker = (props: MUIDatePickerProps<Date | string | undefined, Date>) => {
  return <MUIDatePicker minDate={MIN_DATE} {...props} />
}
